export default {
      id: "yellow_to_red-usage",
      viewBox: "0 0 17 17",
      url: "/" + "images/icons.3.109.2.svg#yellow_to_red-usage",
      toString: function () {
        return this.url;
      }
    }